import SCModal from "@/PageComponents/Modal/SCModal";
import EditTemplateV2 from "@/PageComponents/Settings/Template/EditTemplateV2";

const EditTemplateModal = ({ onSave, setTemplateModalVisibility, template, fromCreate = false}: any) => {

    const onComponentSave = async (id: any) => {
        onSave(id);
        setTemplateModalVisibility(false);
    };

    return (
        <SCModal open size={1200} p={0}>
            <EditTemplateV2
                onSave={onComponentSave}
                template={template}
                fromCreate={fromCreate}
                fromExternalModule={true}
                onCancel={() => setTemplateModalVisibility(false)}
            />
        </SCModal>
    );
};

export default EditTemplateModal;